<template>
  <div class="file-manager-application">
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <div class="content-area-wrapper">

        <SidebarLeft />
        <ContentRight />
      </div>
    </b-overlay>

    <b-modal
      id="modal-category-form"
      title="Tạo mới thư mục"
      size="lg"
      :ok-only="true"
      ok-title="Đóng"
      hide-footer
      centered
    >
      <category-form
        :exist-data="itemData"
        @closeCatFormModal="closeCatFormModal"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay,
} from 'bootstrap-vue'
import SidebarLeft from './components/SidebarLeft.vue';
import ContentRight from './components/ContentRight.vue';
import CategoryForm from './components/CategoryForm.vue';

export default {
  components: {
    ContentRight,
    SidebarLeft,
    CategoryForm,
    BOverlay,
  },
  data() {
    return {
      itemData: {
        name: '',
        parent_id: 0,
      },
    }
  },
  computed: {
    loading() {
      return this.$store.state.files.loading;
    },
    // catData() {
    //   return this.$store.state.files.selected_category
    // },
    // title() {
    //   return this.$store.state.files.selected_category ? 'Cập nhật' : 'Tạo mới';
    // },

  },
  watch: {
    '$store.state.files.show_cat_modal': function () {
      this.openCatFormModal();
    },
  },
  methods: {
    openCatFormModal() {
      this.$bvModal.show('modal-category-form')
    },
    closeCatFormModal() {
      this.$bvModal.hide('modal-category-form')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/base/pages/app-file-manager.scss';
@import '@core/scss/base/plugins/extensions/ext-component-tree.scss';

.file-manager-application {
  .icon {
    margin-right: 5px;

    &:hover {
      cursor: pointer;
    }
  }

  .muted {
    color: gray;
    font-size: 80%;
  }

  .file-status-badge {
    width: 8px;
    height: 8px;
    display: inline-block;
    padding: 0;
    margin-right: 5px;
  }
}
</style>
